export default "__VITE_ASSET__DQSWe6yR__"